import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { formatPrice } from '../data/products';

interface RecentlyViewedItem {
  id: number;
  name: string;
  image: string;
  price: number;
  viewedAt: number;
}

const RecentlyViewed: React.FC = () => {
  const { t } = useTranslation();
  const [items, setItems] = useState<RecentlyViewedItem[]>([]);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const stored = localStorage.getItem('trax-recently-viewed');
    if (stored) {
      const parsed = JSON.parse(stored);
      // Filter out items viewed more than 30 days ago
      const thirtyDaysAgo = Date.now() - 30 * 24 * 60 * 60 * 1000;
      const recent = parsed.filter((item: RecentlyViewedItem) => item.viewedAt > thirtyDaysAgo);
      setItems(recent.slice(0, 10));
      // Update storage
      localStorage.setItem('trax-recently-viewed', JSON.stringify(recent));
    }
  }, []);

  if (items.length === 0) return null;

  return (
    <section className="py-12 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between mb-6">
          <h2 className="text-xl sm:text-2xl font-black text-gray-800 flex items-center gap-2">
            <span>👁️</span>
            {t('home.recentlyViewed', { defaultValue: 'Yakın Zamanda Görüntülenenler' })}
          </h2>
          <button
            onClick={() => setIsVisible(!isVisible)}
            className="text-xs text-[#E31E24] font-semibold hover:underline lg:hidden"
          >
            {isVisible ? t('common.hide', { defaultValue: 'Gizle' }) : t('common.show', { defaultValue: 'Göster' })}
          </button>
        </div>

        <div className={`${isVisible ? 'block' : 'hidden'} lg:block`}>
          <div className="flex gap-4 overflow-x-auto pb-4 scrollbar-hide" style={{ scrollbarWidth: 'none' }}>
            {items.map((item) => (
              <Link
                key={item.id}
                to={`/urun/${item.id}`}
                className="flex-shrink-0 w-40 bg-gray-50 rounded-xl p-3 hover:shadow-md transition-all duration-300 hover:-translate-y-1 group"
              >
                <div className="aspect-square bg-white rounded-lg overflow-hidden mb-2">
                  <img
                    src={item.image}
                    alt={item.name}
                    className="w-full h-full object-contain group-hover:scale-105 transition-transform duration-300"
                    loading="lazy"
                  />
                </div>
                <h3 className="text-xs font-medium text-gray-700 line-clamp-2 mb-1 group-hover:text-[#E31E24] transition-colors">
                  {item.name}
                </h3>
                <span className="text-sm font-bold text-[#E31E24]">{formatPrice(item.price)} ₺</span>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default RecentlyViewed;
